import React from "react";
import { ORDER_STATUS_LABELS } from "../../lib/constants";
import { rub, fmtDateTime } from "../../lib/format";

const btn = "btn-outline !py-1 !px-2 text-xs whitespace-nowrap";

export default function OrderRow({ o, level, onRun, onOpen }) {
  const active = ["new", "in_progress"].includes(o.status);
  return (
    <tr className="border-t border-white/5 align-top" data-testid={`order-row-${o.id}`}>
      <td className="py-3 pr-3"><div className="font-medium">{o.user_name || "—"}</div><div className="text-xs text-gray-500">{o.user_email}</div></td>
      <td className="py-3 pr-3">{o.service_title}{o.price_modified_by_ai && <div className="text-xs text-cyan">цена от AI</div>}</td>
      <td className="py-3 pr-3 text-gold font-mono whitespace-nowrap">{rub(o.price)}</td>
      <td className="py-3 pr-3 text-xs whitespace-nowrap" data-testid={`order-status-${o.id}`}>
        {ORDER_STATUS_LABELS[o.status]}
        {o.overdue && <div className="text-red-400">⏰ Просрочен</div>}
        {o.reject_reason && <div className="text-gray-500 max-w-[160px] whitespace-normal">{o.reject_reason}</div>}
      </td>
      <td className="py-3 pr-3"><span className="chip" data-testid={`order-language-${o.id}`}>{o.language}</span></td>
      <td className={`py-3 pr-3 text-xs whitespace-nowrap ${o.overdue ? "text-red-400" : "text-gray-300"}`}>{fmtDateTime(o.deadline)}</td>
      <td className="py-3 pr-3 text-xs text-gray-500 whitespace-nowrap">{fmtDateTime(o.created_at)}</td>
      <td className="py-3">
        <div className="flex flex-wrap gap-1 max-w-[280px]">
          {o.status === "new" && <button className={btn} onClick={() => onRun(o, "accept")} data-testid={`order-accept-${o.id}`}>✅ Принять</button>}
          {o.status === "in_progress" && <button className={btn} onClick={() => onRun(o, "done")} data-testid={`order-done-${o.id}`}>✅ Оказана</button>}
          {level >= 7 && active && <button className={btn} onClick={() => onOpen("reject")} data-testid={`order-reject-${o.id}`}>❌ Отклонить</button>}
          <button className={btn} onClick={() => onOpen("brief")} data-testid={`order-brief-${o.id}`}>📋 Бриф</button>
          {level >= 7 && (
            <>
              <button className={btn} onClick={() => onOpen("deadline")} data-testid={`order-deadline-${o.id}`}>📅 Дедлайн</button>
              <button className={btn} onClick={() => onOpen("edit")} data-testid={`order-edit-${o.id}`}>✏️</button>
              <button className={btn} onClick={() => onRun(o, "delete")} data-testid={`order-delete-${o.id}`}>🗑️</button>
            </>
          )}
        </div>
      </td>
    </tr>
  );
}
